import { render, staticRenderFns } from "./ListNumLayer.vue?vue&type=template&id=60cbb60c&"
import script from "./ListNumLayer.vue?vue&type=script&lang=js&"
export * from "./ListNumLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports